module.exports = __webpack_public_path__ + "img/faq-bg.6b9d514b.webp";